// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.mobile-container {
  width: 100%;
  max-width: 430px;
  height: 100%;
  border: 6px solid #a3b9d9;
  border-top: 10px solid #a3b9d9;
  border-radius: 1px 1px 1px 1px;
  position: relative;
  flex-wrap: wrap;
  box-sizing: border-box;
  padding: 16px;
  min-height: 568px;
  max-height: 932px;
  min-width: 320px;
}

.Samplies_MOB_Manager_form {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 2em;
  gap: 1em;
  height: calc(100% - 57px);
}
.Samplies_MOB_Manager_form .contr_btns {
  position: absolute;
  bottom: 16px;
  padding: 0 16px;
  box-sizing: border-box;
}
.Samplies_MOB_Manager_form .sku_block {
  align-items: center;
  gap: 10px;
}
.Samplies_MOB_Manager_form .sku_block .inputs {
  display: flex;
  flex-direction: column;
  gap: 15px;
}
@media (max-height: 800px) {
  .Samplies_MOB_Manager_form .sku_block .project_input {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100px;
  }
  .Samplies_MOB_Manager_form .sku_block .inputs {
    width: 30%;
  }
}
.Samplies_MOB_Manager_form .project_input.textereaInput {
  height: 40px;
}
@media (min-height: 600px) {
  .Samplies_MOB_Manager_form .project_input.textereaInput {
    height: clamp(40px, 100%, 100px);
  }
}
.Samplies_MOB_Manager_form .project_input.textereaInput .error {
  bottom: -1em;
}

.sample_photo_container {
  width: 180px;
  height: 180px;
  background: white;
}
@media (min-height: 800px) {
  .sample_photo_container {
    width: 200px;
    height: 200px;
  }
}

.qr_code_container {
  display: flex;
  justify-content: center;
  width: clamp(125px, 50%, 190px);
  height: auto;
  position: relative;
  width: 50%; /* Пример: половина ширины родительского контейнера */
  width: 100%;
}
@media (min-height: 600px) {
  .qr_code_container {
    height: 185px;
  }
}
@media (min-height: 660px) {
  .qr_code_container {
    height: 215px;
  }
}
@media (min-height: 760px) {
  .qr_code_container {
    height: 240px;
  }
}

#qrCodeContainer {
  width: 125px;
  height: 125px;
  border: 1px solid #a3b9d9;
  background: white;
  overflow: hidden;
}
#qrCodeContainer video {
  object-fit: cover;
  width: 100%;
  height: 100%;
}
@media (min-height: 600px) {
  #qrCodeContainer {
    width: 160px;
    height: 160px;
  }
}
@media (min-height: 660px) {
  #qrCodeContainer {
    width: 200px;
    height: 200px;
  }
}
@media (min-height: 760px) {
  #qrCodeContainer {
    width: 210px;
    height: 210px;
  }
}

.sample_img_preview_carusel {
  width: 100%;
  height: calc(100% - 20px);
}
.sample_img_preview_carusel__container {
  width: calc(100vw - 50px);
  height: auto;
}

.skuInput {
  text-align: end;
  padding-right: 15px;
}

.actionsRadioGroup {
  overflow-y: auto;
  padding: 10px 0 10px 20px;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  margin: 5px 0;
}

.scrollY {
  overflow-y: auto;
}`, "",{"version":3,"sources":["webpack://./src/Components/IndexPage/main.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,WAAA;EACA,gBAAA;EAEA,YAAA;EACA,yBAAA;EACA,8BAAA;EACA,8BAAA;EACA,kBAAA;EACA,eAAA;EACA,sBAAA;EACA,aAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;AAAF;;AAUA;EACE,aAAA;EACA,sBAAA;EAEA,mBAAA;EACA,gBAAA;EACA,QAAA;EACA,yBAAA;AARF;AASE;EACE,kBAAA;EACA,YAAA;EACA,eAAA;EAEA,sBAAA;AARJ;AAUE;EAGE,mBAAA;EACA,SAAA;AAVJ;AAYI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAVN;AAYI;EACE;IACE,sBAAA;IACA,mBAAA;IACA,uBAAA;IACA,YAAA;EAVN;EAYI;IACE,UAAA;EAVN;AACF;AAaE;EAGE,YAAA;AAbJ;AAeI;EALF;IAMI,gCAAA;EAZJ;AACF;AAaI;EACE,YAAA;AAXN;;AAgBA;EACE,YAAA;EACA,aAAA;EAGA,iBAAA;AAfF;AA6BE;EAnBF;IAoBI,YAAA;IACA,aAAA;EA1BF;AACF;;AA6BA;EACE,aAAA;EACA,uBAAA;EACA,+BAAA;EACA,YAAA;EACA,kBAAA;EAEA,UAAA,EAAA,qDAAA;EAKA,WAAA;AA/BF;AAkCE;EAfF;IAiBI,aAAA;EAhCF;AACF;AAiCE;EAnBF;IAqBI,aAAA;EA/BF;AACF;AAgCE;EAvBF;IAwBI,aAAA;EA7BF;AACF;;AAoCA;EACE,YAAA;EACA,aAAA;EACA,yBAAA;EACA,iBAAA;EACA,gBAAA;AAjCF;AAkCE;EACE,iBAAA;EACA,WAAA;EACA,YAAA;AAhCJ;AAmCE;EAZF;IAaI,YAAA;IACA,aAAA;EAhCF;AACF;AAiCE;EAhBF;IAiBI,YAAA;IACA,aAAA;EA9BF;AACF;AA+BE;EApBF;IAqBI,YAAA;IACA,aAAA;EA5BF;AACF;;AA+BA;EACE,WAAA;EACA,yBAAA;AA5BF;AA8BE;EACE,yBAAA;EACA,YAAA;AA5BJ;;AAgCA;EACE,eAAA;EACA,mBAAA;AA7BF;;AAgCA;EAEE,gBAAA;EAEA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,aAAA;AA/BF;;AAiCA;EACE,gBAAA;AA9BF","sourcesContent":["@import \"../App/style/vars.scss\";\n.mobile-container {\n  width: 100%;\n  max-width: 430px;\n  //   margin-top: 4.2em;\n  height: 100%;\n  border: 6px solid #a3b9d9;\n  border-top: 10px solid #a3b9d9;\n  border-radius: 1px 1px 1px 1px;\n  position: relative;\n  flex-wrap: wrap;\n  box-sizing: border-box;\n  padding: 16px;\n  min-height: 568px;\n  max-height: 932px;\n  min-width: 320px;\n\n  //   min-height: calc(576px - 4.2em);\n  // .qrContainer{\n  //   padding: 0;\n  // }\n}\n\n.limited-size-container {\n}\n.Samplies_MOB_Manager_form {\n  display: flex;\n  flex-direction: column;\n  //   justify-content: center;\n  align-items: center;\n  padding-top: 2em;\n  gap: 1em;\n  height: calc(100% - 57px);\n  .contr_btns {\n    position: absolute;\n    bottom: 16px;\n    padding: 0 $windowPadding;\n\n    box-sizing: border-box;\n  }\n  .sku_block {\n    // width: clamp(180px, 50%, 210px);\n    // height: clamp(180px, 50%, 210px);\n    align-items: center;\n    gap: 10px;\n    // min-height: 180px;\n    .inputs {\n      display: flex;\n      flex-direction: column;\n      gap: 15px;\n    }\n    @media (max-height: 800px) {\n      .project_input {\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        width: 100px;\n      }\n      .inputs {\n        width: 30%;\n      }\n    }\n  }\n  .project_input.textereaInput {\n    // height: 100%;\n\n    height: 40px;\n    // }\n    @media (min-height: 600px) {\n      height: clamp(40px, 100%, 100px);\n    }\n    .error {\n      bottom: -1em;\n    }\n  }\n}\n\n.sample_photo_container {\n  width: 180px;\n  height: 180px;\n  // width: clamp(180px, 60%, 210px);\n  // height: clamp(180px, 60%, 210px);\n  background: white;\n  //   width: 50%; /* Пример: половина ширины родительского контейнера */\n  //   padding-bottom: 50%; /* Сохраняет соотношение 1:1 для квадрата */\n  //   box-sizing: border-box;\n\n  // @media screen and (min-width: 320px) and (min-height: 568px) {\n  //   width: 180px;\n  //   height: 180px;\n  // }\n  // @media screen and (min-width: 376px) and (min-height: 600px) {\n  //   width: 70%; /* Пример: половина ширины родительского контейнера */\n  //   padding-bottom: 70%;\n  // }\n\n  @media (min-height: 800px) {\n    width: 200px;\n    height: 200px;\n  }\n}\n\n.qr_code_container {\n  display: flex;\n  justify-content: center;\n  width: clamp(125px, 50%, 190px);\n  height: auto;\n  position: relative;\n  // background: white;\n  width: 50%; /* Пример: половина ширины родительского контейнера */\n  // padding-bottom: 50%; /* Сохраняет соотношение 1:1 для квадрата */\n  // box-sizing: border-box;\n  //   max-width: 190px;\n  //   max-height: 190px;\n  width: 100%;\n  // height: 150px;\n  // margin-bottom: 2em;\n  @media (min-height: 600px) {\n    // width: 160px;\n    height: 185px;\n  }\n  @media (min-height: 660px) {\n    // width: 180px;\n    height: 215px;\n  }\n  @media (min-height: 760px) {\n    height: 240px;\n  }\n  // @media (min-height: 700px) {\n  //   // width: 180px;\n  //   height: 215px;\n  // }\n}\n\n#qrCodeContainer {\n  width: 125px;\n  height: 125px;\n  border: 1px solid #a3b9d9;\n  background: white;\n  overflow: hidden;\n  video {\n    object-fit: cover;\n    width: 100%;\n    height: 100%;\n  }\n\n  @media (min-height: 600px) {\n    width: 160px;\n    height: 160px;\n  }\n  @media (min-height: 660px) {\n    width: 200px;\n    height: 200px;\n  }\n  @media (min-height: 760px) {\n    width: 210px;\n    height: 210px;\n  }\n}\n\n.sample_img_preview_carusel {\n  width: 100%;\n  height: calc(100% - 20px);\n\n  &__container {\n    width: calc(100vw - 50px);\n    height: auto;\n  }\n}\n\n.skuInput {\n  text-align: end;\n  padding-right: 15px;\n}\n\n.actionsRadioGroup {\n  // max-height: 630px;\n  overflow-y: auto;\n\n  padding: 10px 0 10px 20px;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  margin: 5px 0;\n}\n.scrollY {\n  overflow-y: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
